import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextView, pd, PhoenixThemeProvider } from '@airasia-phoenix/web';
import TripSummary from './TripSummary';

const color = pd.sys.colour;
const font = pd.sys.typescale;

const CardWrapper = styled.div`
  border: 1px solid ${color.outline_low.color()};
  border-radius: 16px;
  background-color: white;
  height: 224px;
`;

const TwoLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 12px;
  position: relative;
`;

const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 24px;
  margin-left: 24px;
`;

const TwoLineTripSummary = ({
  departLabel,
  returnLabel,
  departure,
  arrival,
  carrierLogo,
  carrierLogo1,
  carrierLogo2,
  returnCarrierLogo,
  returnCarrierLogo1,
  returnCarrierLogo2,
  changeFlight,
  airlineNameDepart,
  airlineNameReturn,
  title,
  changeFlightLabel,
  origin,
  destination,
  handleIconClick,
}) => {
  const lineStyle = {
    minWidth: '120px',
    maxWidth: '120px',
  };

  const summaryRowContentStyles = {
    justifyContent: 'space-between',
    alignItems: 'center',
    style: { width: '342px' },
  };

  return (
    <PhoenixThemeProvider>
      <CardWrapper>
        <TitleWrapper>
          <TextView data-testid="title-text" font={font.body_text_medium}>
            {title}
          </TextView>
          <TextView
            data-testid="change-flight-link"
            style={{ cursor: 'pointer' }}
            color={color.interactive_link.color()}
            font={font.sub_body_text}
            onClick={changeFlight}
          >
            {changeFlightLabel}
          </TextView>
        </TitleWrapper>
        <TwoLineWrapper>
          {/* Departure Flight */}
          <SummaryWrapper>
            <TripSummary
              tripType={departLabel}
              departTime={departure?.departTime}
              arrivalTime={departure?.arrivalTime}
              duration={departure?.duration}
              origin={origin}
              destination={destination}
              airlineName={airlineNameDepart}
              carrierLogo={carrierLogo}
              carrierLogo1={carrierLogo1}
              carrierLogo2={carrierLogo2}
              legs={departure?.legs}
              days={departure?.days || '0'}
              lineStyle={lineStyle}
              summaryRowContentStyles={summaryRowContentStyles}
              handleIconClick={handleIconClick}
              {...departure}
            />
          </SummaryWrapper>

          {/* Return Flight */}
          <SummaryWrapper>
            <TripSummary
              tripType={returnLabel}
              departTime={arrival?.departTime}
              arrivalTime={arrival?.arrivalTime}
              duration={arrival?.duration}
              origin={destination}
              destination={origin}
              airlineName={airlineNameReturn}
              carrierLogo={returnCarrierLogo}
              carrierLogo1={returnCarrierLogo1}
              carrierLogo2={returnCarrierLogo2}
              legs={arrival?.legs}
              days={arrival?.days || '0'}
              lineStyle={lineStyle}
              summaryRowContentStyles={summaryRowContentStyles}
              handleIconClick={handleIconClick}
              {...arrival}
            />
          </SummaryWrapper>
        </TwoLineWrapper>
      </CardWrapper>
    </PhoenixThemeProvider>
  );
};

TwoLineTripSummary.propTypes = {
  departLabel: PropTypes.string,
  returnLabel: PropTypes.string,
  departure: PropTypes.object,
  arrival: PropTypes.object,
  carrierLogo: PropTypes.string,
  carrierLogo1: PropTypes.string,
  carrierLogo2: PropTypes.string,
  returnCarrierLogo: PropTypes.string,
  returnCarrierLogo1: PropTypes.string,
  returnCarrierLogo2: PropTypes.string,
  changeFlight: PropTypes.func,
  title: PropTypes.string,
  changeFlightLabel: PropTypes.string,
  airlineNameDepart: PropTypes.string,
  airlineNameReturn: PropTypes.string,
  origin: PropTypes.string,
  destination: PropTypes.string,
  handleIconClick: PropTypes.func,
};

TwoLineTripSummary.defaultProps = {
  departLabel: 'Depart',
  returnLabel: 'Return',
  carrierLogo: '',
  carrierLogo1: '',
  carrierLogo2: '',
  returnCarrierLogo: '',
  returnCarrierLogo1: '',
  returnCarrierLogo2: '',
  title: 'Flight summary',
  changeFlightLabel: 'Change Flight',
  airlineNameDepart: '',
  airlineNameReturn: '',
  handleIconClick: () => {},
};

export default TwoLineTripSummary;
